import ColorPicker from './ColorPicker';
export default ColorPicker;
//# sourceMappingURL=index.js.map